export const getPostDetailPayload = (response) =>
  response?.data?.data || response?.data || {};

export const getPostsListPayload = (response) => {
  const payload = response?.data?.data || response?.data || {};
  const posts = payload.posts || payload;

  return {
    posts: Array.isArray(posts) ? posts : [],
    pagination: payload.pagination || response?.data?.pagination || {},
  };
};

export const getPostFileUrl = (post = {}) => post.fileUrl || post.fireUrl || "";
